var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from 'elements/Loading';
import { getSaleExtra } from '../Stretch';
import History from 'helpers/History';
import Storage from 'helpers/Storage';
import { getSale } from '../../Utils/Util';
import { checkDisabledDay, filterHoursFromDay, lengths } from '../../../helpers/Utils';
import StretchesDetailView from './StretchesDetailView';
import { TypeTicket } from '../../Detail/DetailRoutes';
import { T } from '../../../helpers/i18n';
import { TypeDiscount } from '../../DiscountReasons/IDiscount';
import { TypePrice } from '../../PassengerCategories/Model';
import { PaymentMethod } from '../../../Models/TicketPayment';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import QRCodeSVG from '../../../elements/QRCode';
let StretchesDetail = class StretchesDetail extends Component {
    constructor(props) {
        var _a, _b, _c, _d;
        super(props);
        this.state = {
            loading: false,
            sale: [],
            saleExtra: [],
            // dateBooking: Moment(new Date()).format('DD/MM/YYYY'),
            descuento: undefined,
            codigoDescuento: undefined,
            diasValido: 1,
            numeroTicketGratis: '',
            busy: false,
            busyNotsend: false,
            valitedNow: this.props.store.tempTicketStore.tempSaleTicket.valitedNow || false,
            ticketCheckins: '',
            message: '',
            code: undefined,
            result: '',
            visible: false,
            datePickerVisible: false,
            // date: new Date(),
            fechaAtrasada: false,
            cash: 'cash',
            isPrinting: false,
            showModalContact: false,
            visibleExtras: false,
            visiblePayments: true,
            visibleDataweb: true,
            showModal: false,
            numero: ''
        };
        this.afiliatesOptions = this.props
            ? this.props.afiliates
                ? ((_b = (_a = this.props.store.users) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.afiliate) ? [
                    {
                        name: this.props.store.users.user.afiliate.name,
                        value: this.props.store.users.user.afiliate.id.toString(),
                    },
                ]
                    : [
                        { name: T('select'), value: null },
                        ...this.props.afiliates.map((afiliate) => {
                            return {
                                name: afiliate.name,
                                value: String(afiliate.id),
                            };
                        }),
                    ]
                : []
            : [];
        this.discountReasonsOptions = this.props
            ? this.props.discountReasons
                ? [
                    { name: T('select'), value: null },
                    ...this.props.discountReasons.map((discountReason) => {
                        return {
                            name: discountReason.name,
                            value: String(discountReason.id),
                        };
                    }),
                ]
                : []
            : [];
        this.handleKeyMinus = (item) => {
            // this.handleFecha()
            this.props.store.tempTicketStore.tempSaleTicket.setMinus(item);
            this.getAforo();
        };
        this.handleKeyPlus = (item) => {
            if (this.errorAforo(true)) {
                return;
            }
            // this.handleFecha()
            // console.log('handleKeyPlus - item: ', item)
            const tempSaleTicket = this.props.store.tempTicketStore.tempSaleTicket;
            // compruebo que no se añada más del máximo configurado si el precio es no es por grupo y  es unitario
            if (item.stretchPrice.passengerCategory.type !== TypePrice.byGroup &&
                this.props.stretch.unitary) {
                if (this.props.stretch.capacity !== 0 && !this.props.stretch.capacity) {
                    return this.props.store.UI.newError('El servicio no ha sido configurado correctamente, falta añadir capacidad');
                }
                if (tempSaleTicket.checkins + 1 > this.props.stretch.capacity) {
                    return this.props.store.UI.newWarning(`${T('maximumCapacityReached')} : ${this.props.stretch.capacity}`);
                }
            }
            tempSaleTicket.setPlus(item);
            this.getAforo();
        };
        this.errorMinCategory = () => {
            const tempSaleTicket = this.props.store.tempTicketStore.tempSaleTicket;
            let error = false;
            for (const line of tempSaleTicket.lines) {
                const quantity = line.quantity;
                const minToReserve = line.stretchPrice.passengerCategory.minToReserve;
                if (quantity < minToReserve) {
                    error = true;
                    break;
                }
            }
            return error;
        };
        this.handleFecha = () => {
            const { stretch } = this.props;
            if (stretch.tramoHora) {
                const fechaActual = new Date();
                fechaActual.setMinutes(fechaActual.getMinutes());
                // const fechaBook = this.state.date
                const fechaBook = this.props.store.tempTicketStore.tempSaleTicket.datebook;
                fechaBook.setHours(stretch.hours);
                fechaBook.setMinutes(stretch.minutes);
                console.warn('fechaBook: ', fechaBook);
                if (fechaActual > fechaBook) {
                    // fechaBook.setDate(fechaBook.getDate() + 1)
                    // const fechaString = Moment(fechaBook).format('DD/MM/YYYY')
                    // this.setState({dateBooking: fechaString})
                    // console.log('nueva fechaBooking: ', fechaString)
                    // this.props.store.tempTicketStore.tempSaleTicket.setDatebook(fechaBook)
                    this.setState({ fechaAtrasada: true });
                }
            }
        };
        this.quantity = (item) => {
            return this.props.store.tempTicketStore.tempSaleTicket.getQuantity(item);
        };
        this.lineTotal = (item) => {
            return this.props.store.tempTicketStore.tempSaleTicket.getLineTotal(item);
        };
        this.handleResetCount = () => {
            this.setState({ ticketCheckins: 0 });
            Storage.set('stretch' + String(this.props.stretch.id), '0');
        };
        this.handleCheckOut = (isPaymentlink) => __awaiter(this, void 0, void 0, function* () {
            const tempTicketStore = this.props.store.tempTicketStore;
            const chekins = tempTicketStore.tempSaleTicket.checkins;
            if (this.props.typeTicket === TypeTicket.CollaboratorStretch) {
                this.setState({ loading: true });
                console.log('generando ticket en colaboración');
                tempTicketStore
                    .createSale()
                    .then((value) => {
                    this.props.store.UI.newOk('Ticket generado correctamente', true);
                    this.setState({ loading: false });
                    console.log('handleCheckOut - then - venta ok');
                })
                    .catch((reason) => {
                    this.setState({ loading: false });
                    this.props.store.UI.newError(reason.message);
                    console.log('handleCheckOut - catch - se ha producido un error: ', reason);
                });
                return;
            }
            else if (this.props.typeTicket === TypeTicket.Stretch) {
                tempTicketStore
                    .createTicket(isPaymentlink)
                    .then((response) => {
                    if ((response === null || response === void 0 ? void 0 : response.code) !== 200) {
                        return;
                    }
                    this.props.store.UI.newOk('Ticket generado correctamente');
                    this.setState((prev) => ({
                        ticketCheckins: prev.ticketCheckins + chekins,
                        showModal: true,
                        numero: response.numero
                    }), () => __awaiter(this, void 0, void 0, function* () {
                        Storage.set('stretch' + String(this.props.stretch.id), String(this.state.ticketCheckins));
                        yield this.props.store.reports.readTickets();
                    }));
                })
                    .catch((reason) => {
                    console.log('StretechesDetail - handleCheckOut - catch - reason: ', reason);
                });
                // this.meteTodos()
                // this.pruebaAsync()
                this.getAforo();
            }
        });
        this.handleCheckbox = (name, value) => {
            // console.log('StretchesDetail - handleCheckbox - name: ', name)
            // console.log('StretchesDetail - handleCheckbox - value: ', value)
            switch (name) {
                case 'printPrice':
                    this.props.store.tempTicketStore.tempSaleTicket.setPrintPrice(value);
                    break;
                case 'valitedNow':
                    this.props.store.tempTicketStore.tempSaleTicket.setValitedNow(value);
                    break;
                case 'boardingPass':
                    this.props.store.tempTicketStore.tempSaleTicket.setBoardingPass(value);
                    break;
                default:
            }
        };
        this.handleScan = () => {
            const { selected } = this.props.store.reports;
            /*const {name} = this.props.stretch*/
            const { name } = this.props.stretch.operationLine;
            console.log('handleScan() - selected: - name: ', selected, name);
            this.props.store.reports
                .validaNumero(this.props.store.reports.selected, name)
                .then((value) => {
                console.log('StretchesDetail - handleScan - then - value: ', value);
                const { result, code, message } = value;
                this.setState({ result, code, message, visible: true }, () => {
                    this.props.store.reports.readTickets();
                });
                if (value.code !== 200) {
                }
                else {
                }
            })
                .catch((error) => { });
        };
        this.handleClose = () => {
            this.setState((prevState) => ({ visible: !prevState.visible }));
        };
        this.handleCloseFechaAtrasada = () => {
            this.setState((prevState) => ({ fechaAtrasada: !prevState.fechaAtrasada }));
        };
        this.toggleToModal = () => this.props.stretch && this.props.stretch.type !== 'event' && this.setState((prevState) => ({
            datePickerVisible: !prevState.datePickerVisible,
        }));
        this.handleDate = (_, date) => {
            this.props.store.tempTicketStore.tempSaleTicket.setDatebook(date);
            const now = new Date();
            // manejo hora apropiada sólo si es el día actual
            if (now.getFullYear() === date.getFullYear() &&
                now.getMonth() === date.getMonth() &&
                now.getDate() === date.getDate()) {
                this.props.store.tempTicketStore.tempSaleTicket.handleChangeDate();
            }
            this.toggleToModal();
            this.getAforo();
        };
        this.handleAllMoneyClick = (method) => {
            if (!method) {
                return;
            }
            const { tempSaleTicket } = this.props.store.tempTicketStore;
            tempSaleTicket.setAllMoneyToPaymentMethod(method);
        };
        this.handleInputMethod = (event, ref) => {
            if (!ref) {
                return;
            }
            const name = ref.current.name;
            if (event.currentTarget.value === '') {
                return;
            }
            const numero = Number(event.currentTarget.value);
            if (Number.isNaN(numero)) {
                return this.props.store.UI.newWarning('Valor introducido no válido');
            }
            switch (name) {
                case PaymentMethod.Card:
                    this.props.store.tempTicketStore.tempSaleTicket.setInputCard(numero);
                    break;
                case PaymentMethod.Due:
                    this.props.store.tempTicketStore.tempSaleTicket.setInputDefer(numero);
                    break;
                case PaymentMethod.Credit:
                    this.props.store.tempTicketStore.tempSaleTicket.setInputCredit(numero);
                    break;
                case PaymentMethod.Transfer:
                    this.props.store.tempTicketStore.tempSaleTicket.setInputTransfer(numero);
                    break;
                case PaymentMethod.Other:
                    this.props.store.tempTicketStore.tempSaleTicket.setInputOther(numero);
                    break;
                default:
                    this.props.store.UI.newWarning('Error procesando métodos de pago');
            }
        };
        this.handleInputDiscount = (event) => {
            const isNumeric = (n) => {
                return !isNaN(parseFloat(n)) && isFinite(n);
            };
            const numero = event.target.value;
            if (numero === '') {
                return this.props.store.tempTicketStore.tempSaleTicket.setDiscount(null);
            }
            if (isNumeric(numero)) {
                if (numero >= 100 &&
                    this.props.store.tempTicketStore.tempSaleTicket.typeDiscount ===
                        TypeDiscount.Percentage) {
                    this.props.store.tempTicketStore.tempSaleTicket.setDiscount(100);
                }
                else {
                    this.props.store.tempTicketStore.tempSaleTicket.setDiscount(numero);
                }
            }
            else {
                this.props.store.tempTicketStore.tempSaleTicket.setDiscount(this.props.store.tempTicketStore.tempSaleTicket.discount);
                this.props.store.UI.newWarning('Valor introducido no válido');
            }
        };
        this.handleName = () => {
            this.setState({ showModalContact: true });
        };
        this.handleAfiliateDiscountReasonChange = (type, name, value, column) => {
            if (type === 'afiliate') {
                // he cambiado afiliado
                const afiliate = this.props.store.afiliatesStore.data.find((item) => item.id === Number(value));
                const sale = getSale(this.props.stretch, this.props.store.tempTicketStore.tempSaleTicket.saleVuelta, afiliate);
                this.props.store.tempTicketStore.tempSaleTicket.setAfiliate(afiliate);
                this.props.store.tempTicketStore.tempSaleTicket.setSale(sale);
                this.setState({ sale });
            }
            else if (type === 'discountReason') {
                // he cambiado razón de descuento
                const discountReason = this.props.store.discountReasonsStore.data.find((item) => item.id === Number(value));
                this.props.store.tempTicketStore.tempSaleTicket.setDiscountReason(discountReason ? discountReason.name : '');
            }
        };
        this.quantityExtras = (item) => {
            return this.props.store.tempTicketStore.tempSaleTicket.getQuantityExtras(item);
        };
        this.lineTotalExtras = (item) => {
            return this.props.store.tempTicketStore.tempSaleTicket.getLineTotalExtras(item);
        };
        this.handleKeyMinusExtras = (item) => {
            // this.handleFecha()
            this.props.store.tempTicketStore.tempSaleTicket.setExtraMinus(item);
            // this.sendToLcdTotal()
        };
        this.handleKeyPlusExtras = (item) => {
            // this.handleFecha()
            this.props.store.tempTicketStore.tempSaleTicket.setExtraPlus(item);
            // this.sendToLcdTotal()
        };
        this.handleClickExtra = () => {
            this.setState((prev) => ({ visibleExtras: !prev.visibleExtras }));
        };
        this.handleClickPayments = () => {
            this.setState((prev) => ({ visiblePayments: !prev.visiblePayments }));
        };
        this.handleCloseModalPayments = () => {
            this.setState({ visiblePayments: false });
        };
        this.handleChangeDataweb = (name, value, column) => {
            this.props.store.tempTicketStore.tempSaleTicket.setKeyValueDataContact(column ? column : name, value);
        };
        this.onHandleVisibleDataweb = () => {
            this.setState((prev) => ({ visibleDataweb: !prev.visibleDataweb }));
        };
        this.handleChangeHours = (value) => {
            this.props.store.tempTicketStore.tempSaleTicket.setTimeIda(value);
            this.getAforo();
        };
        this.getDataAforo = () => {
            const tempSaleTicket = this.props.store.tempTicketStore.tempSaleTicket;
            const datebook = tempSaleTicket.datebook;
            datebook.setHours(tempSaleTicket.timeIda.hours, tempSaleTicket.timeIda.minutes, 0, 0);
            const data = {
                datebook,
            };
            let origin, destination, vuelta;
            if (tempSaleTicket.stretch.vuelta) {
                origin = tempSaleTicket.originDestination.origin;
                destination = tempSaleTicket.originDestination.destination;
                vuelta = true;
            }
            const stretch_id = tempSaleTicket.stretch.id;
            const operator_id = tempSaleTicket.operator_id;
            return {
                operator_id,
                stretch_id,
                datebook,
                origin,
                destination,
                vuelta,
            };
        };
        this.getAforo = () => {
            if (this.isWithAforo()) {
                const dataAforo = this.getDataAforo();
                this.props.store.aforoStore.getAforo(dataAforo).then((value) => {
                    // console.log('getAforo - value: ', value)
                });
            }
        };
        this.isWithAforo = () => {
            return this.props.store.tempTicketStore.tempSaleTicket.timeIda;
        };
        this.canAddQuantity = () => {
            if (this.isWithAforo()) {
                return (this.props.store.aforoStore.quantityAvailable -
                    this.props.store.tempTicketStore.tempSaleTicket.quantityToAdd >
                    0);
            }
            return true;
        };
        this.errorAforo = (handlePlus) => {
            var _a;
            let errorAforo = false;
            if (this.props.stretch.capacity &&
                this.props.stretch.capacity > 0 &&
                ((_a = this.props.stretch.horasIda) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const disponible = this.props.store.aforoStore.quantityAvailable -
                    this.props.store.tempTicketStore.tempSaleTicket.quantityToAdd;
                if (handlePlus) {
                    errorAforo = disponible <= 0;
                }
                else {
                    errorAforo = disponible < 0;
                }
            }
            return errorAforo;
        };
        // console.log('stretch: ', this.props.stretch)
        // para cuando el servicio está deshabilitado en virtual
        // @ts-ignore
        if (!this.props.stretch ||
            this.props.stretch.disabled_at ||
            this.props.stretch.disableVirtual) {
            return;
        }
        const { tempTicketStore } = this.props.store;
        const { tempSaleTicket } = this.props.store.tempTicketStore;
        tempSaleTicket.reset();
        tempTicketStore.setTypeTicket(props.typeTicket);
        tempSaleTicket.setOperationLine(this.props.stretch.operationLine);
        tempSaleTicket.setStretch(this.props.stretch);
        this.props.store.aforoStore.capacity = this.props.stretch.capacity;
        this.props.store.aforoStore.unit = this.props.stretch.units;
        if ((_d = (_c = this.props.store.users) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 : _d.afiliate) {
            tempSaleTicket.setAfiliate(this.props.store.users.user.afiliate);
        }
        this.state.sale = getSale(this.props.stretch, tempSaleTicket.saleVuelta, tempSaleTicket.afiliate);
        if (this.props.stretch && this.props.stretch.extras) {
            this.state.saleExtra = getSaleExtra(this.props.stretch);
        }
        // cuando el servicio es propio client_id y operator_id es el mismo
        tempSaleTicket.setClientId(this.props.store.users.user.client_id);
        tempSaleTicket.setOperatorId(this.props.store.users.user.client_id);
        // si el servicio es en colaboración
        if (props.typeTicket === TypeTicket.CollaboratorStretch) {
            tempSaleTicket.setCollaboratorName(this.props.store.users.user.client);
            tempSaleTicket.setOperatorId(this.props.stretch.operator_id);
            tempSaleTicket.setOperatorName(this.props.stretch.operatorName);
        }
    }
    componentDidMount() {
        const hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        // console.log('StretchesDetail - componentDidMount - hasParent', hasParent)
        this.props.store.UI.changeHasParent(hasParent);
        // const ticketCheckins = Storage.get('stretch' + String(this.props.stretch.id))
        // console.log('value: ', ticketCheckins)
        // this.setState({ticketCheckins: Number(ticketCheckins)})
        this.getAforo();
        if (this.props.stretch && this.props.stretch.type === 'event' && this.props.stretch.dateEvent) {
            this.props.store.tempTicketStore.tempSaleTicket.setDatebook(new Date(this.props.stretch.dateEvent));
            if (this.props.stretch.horasIda && this.props.stretch.horasIda.length === 1) {
                this.props.store.tempTicketStore.tempSaleTicket.setTimeIda(this.props.stretch.horasIda[0]);
            }
        }
    }
    render() {
        var _a, _b;
        // const innerHeight = window.innerHeight
        // const vh = innerHeight * 0.01
        // console.log('StretchesDetail - vh: ', vh)
        const { stretch } = this.props;
        const { sale, saleExtra, ticketCheckins, visible, code, message, result, datePickerVisible, 
        /*dateBooking, date,*/ fechaAtrasada, visiblePayments, visibleDataweb, } = this.state;
        const { total, discount, printPrice } = this.props.store.tempTicketStore.tempSaleTicket;
        const dateBooking = this.props.store.tempTicketStore.tempSaleTicket.datebook
            ? this.props.store.tempTicketStore.tempSaleTicket.datebook
            : new Date();
        const valitedNow = this.props.store.tempTicketStore.tempSaleTicket.valitedNow;
        const boardingPass = this.props.store.tempTicketStore.tempSaleTicket.boardingPass;
        const tieneDescuento = discount > 0;
        const descuentoAplicado = `${discount} %`;
        const isSelected = this.props.store.reports.selected !== '';
        const { tipoPago } = this.props.store.tempTicketStore.tempSaleTicket;
        const tempSaleTicket = this.props.store.tempTicketStore.tempSaleTicket;
        const errorTotal = tempSaleTicket.totalDue +
            tempSaleTicket.totalCard +
            tempSaleTicket.totalCredit +
            tempSaleTicket.totalTransfer +
            tempSaleTicket.totalOther >
            tempSaleTicket.total;
        // compruebo el día seleccionado está deshabilitado
        const disabledDays = stretch.disabledDays;
        const dateToCheck = tempSaleTicket.datebook || new Date();
        const checkins = tempSaleTicket.checkins;
        const totalWithoutDiscount = tempSaleTicket.totalWithoutDiscount;
        const busy = this.props.store.tempTicketStore.busy;
        const busyNotSend = this.props.store.cashDeskTicketStore.busy;
        /* console.log('---------')
         console.log('busy: ', busy)
         console.log('---------')*/
        const disabledDate = checkDisabledDay(stretch.horasIda, disabledDays, dateToCheck);
        const errorMinCategory = this.errorMinCategory();
        const disableCheckout = errorMinCategory ||
            disabledDate ||
            busy ||
            busyNotSend ||
            checkins === 0 ||
            totalWithoutDiscount <
                tempSaleTicket.totalDiscount /*|| totalWithoutDiscount === 0*/ ||
            errorTotal;
        // console.log('StretchesDetail - disableCheckout: ', disableCheckout)
        const disablePrintLast = !disableCheckout || this.state.isPrinting;
        const enablePaymentCredit = !!tempSaleTicket.afiliate;
        const hoursFiltered = filterHoursFromDay(stretch.horasIda, stretch.disabledDays, tempSaleTicket.datebook);
        const visibleExtras = this.state.visibleExtras;
        let height = visibleExtras ? 65 : 70;
        const limite = 8;
        let paddingBloque = 15;
        const cantidad = sale.length;
        if (cantidad > 4) {
            paddingBloque = visibleExtras ? 8 : 6;
            height = visibleExtras ? 60 : 65;
            if (cantidad > limite) {
                paddingBloque = visibleExtras ? 6 : 4;
                height = visibleExtras ? 55 : 60;
            }
        }
        const errorAforo = this.errorAforo();
        const provider = this.props.store.users.user.client;
        const type = this.state.numero.length === lengths.stretch ? TypeTicket.Stretch : TypeTicket.CollaboratorStretch;
        const url = `${process.env.REACT_APP_SERVER}getticket/${provider}/${type}/${this.state.numero}`;
        return (React.createElement("div", { className: "p-4 text-center" },
            React.createElement(Modal, { centered: true, isOpen: this.state.showModal },
                React.createElement(ModalHeader, { toggle: () => {
                        this.setState({ showModal: false });
                    } }, "Descarga mediante QR"),
                React.createElement(ModalBody, null,
                    React.createElement("div", { className: "text-center py-4" },
                        React.createElement(QRCodeSVG, { value: url, size: 200, level: 'H' })),
                    React.createElement("p", { className: "text-muted mb-0 fw-bold" }, "Escanea el c\u00F3digo QR con la c\u00E1mara de tu m\u00F3vil para iniciar la descarga."))),
            React.createElement(StretchesDetailView, { afiliateName: ((_a = tempSaleTicket.afiliate) === null || _a === void 0 ? void 0 : _a.name) || '', loading: this.state.loading, stretch: stretch, dateBooking: dateBooking, ticketCheckins: ticketCheckins, valitedNow: valitedNow, disableCheckout: disableCheckout, disablePrintLast: disablePrintLast, printPrice: printPrice, discount: discount, tempSaleTicket: tempSaleTicket, sale: sale, tieneDescuento: tieneDescuento, descuentoAplicado: descuentoAplicado, visible: visible, fechaAtrasada: fechaAtrasada, message: (_b = this.props.store.UI.message) === null || _b === void 0 ? void 0 : _b.text, result: result, afiliatesOptions: this.afiliatesOptions, discountReasonsOptions: this.discountReasonsOptions, datePickerVisible: datePickerVisible, hoursFiltered: hoursFiltered, onHandleChangeHours: this.handleChangeHours, lineTotal: this.lineTotal, visibleExtras: visibleExtras, quantity: this.quantity, height: height, saleExtra: saleExtra, paddingBloque: paddingBloque, busy: busy, quantityExtras: this.quantityExtras, lineTotalExtras: this.lineTotalExtras, onHandleKeyMinusExtras: this.handleKeyMinusExtras, onHandleKeyPlusExtras: this.handleKeyPlusExtras, onHandleClickExtra: this.handleClickExtra, errorTotal: errorTotal, onHandleInputMethod: this.handleInputMethod, ohHandleAllMoneyClick: this.handleAllMoneyClick, enablePaymentCredit: enablePaymentCredit, onToggleToModal: this.toggleToModal, onHandleCheckbox: this.handleCheckbox, onHandleCheckOut: this.handleCheckOut, onHandleName: this.handleName, onHandleKeyMinus: this.handleKeyMinus, onHandleKeyPlus: this.handleKeyPlus, onHandleClose: this.handleClose, onHandleCloseFechaAtrasada: this.handleCloseFechaAtrasada, onHandleDate: this.handleDate, onHandleAfiliateDiscountReasonChange: this.handleAfiliateDiscountReasonChange, onHandleInputDiscount: this.handleInputDiscount, onPressIdaVuelta: (vuelta) => {
                    // if (stretch.vueltaPrices) {
                    tempSaleTicket.setSaleVuelta(vuelta);
                    this.setState({
                        sale: getSale(stretch, tempSaleTicket.saleVuelta, tempSaleTicket.afiliate),
                    });
                    // }
                }, toggleOriginDestination: () => {
                    tempSaleTicket.toggleOriginDestination();
                    this.getAforo();
                }, visiblePayments: visiblePayments, onHandleClickPayments: this.handleClickPayments, onCloseModalPayments: this.handleCloseModalPayments, visibleDataweb: visibleDataweb, onHandleChangeDataweb: this.handleChangeDataweb, onHandleVisibleDataweb: this.onHandleVisibleDataweb, disabledDate: disabledDate, boardingPass: boardingPass, disableboardingPass: 
                // para mostrar o no checkbox boardingPass
                this.props.typeTicket === TypeTicket.CollaboratorStretch, disableValitedNow: this.props.typeTicket === TypeTicket.CollaboratorStretch, errorAforo: errorAforo })));
    }
};
StretchesDetail = __decorate([
    inject('store'),
    loading((props) => {
        return [
            /*props.store.stretchesStore
              .read(props.match.params.id)
              .then(stretch => ({stretch})),*/
            props.store.afiliatesStore.read().then((afiliates) => ({ afiliates })),
            props.store.discountReasonsStore
                .read()
                .then((discountReasons) => ({ discountReasons })),
        ];
    }),
    observer
], StretchesDetail);
export default StretchesDetail;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/StretchesDetail.tsx
// module id = 366
// module chunks = 0